import { ThreePointsType } from 'state';
import { AppRootStateType } from 'state/reducers';

export const selectThreePoints = (state: AppRootStateType): ThreePointsType[] =>
  state.threePoints.threePoints;
